import { createGlobalStyle } from "styled-components";

export const LightTheme = {};

export const GlobalStyle = createGlobalStyle`

    :root{
        --main-color :  radial-gradient( circle farthest-corner at 10% 20%,  rgba(37,145,251,0.98) 0.1%, rgba(0,7,128,1) 99.8% );
        --light-blue : rgba(37,145,251,0.98) ;
        --light-sky : rgba(37,145,251,0.15) ;
        --dark : #101010;
        --dark-gray : #333;
        --light-gray: #f4f4f4;
        --gray:#999;
        --white : #fff;
        --border-light: #9999992b;
        --box-shadow: #d1d1d180;
        --border-radius :1rem;
        --body-color:#ffffff;
        --form-color:#fff;
       // --box-shadow: "0 5px 8px #d1d1d180";  
    }


    [data-theme="dark"]{
       --body-color: #000000;
       --white : #171717;
       --dark : #888888;
       --box-shadow: #3c3b3b42;
       --light-gray: #2b2a2a;
       --dark-gray : #999;
       --form-color:rgb(255 255 255 / 13%);
    }

    *{
        margin:0 ;
        padding:0 ;
        box-sizing: border-box;
    }
    body{
        font-family: 'Poppins', sans-serif;
        font-size:16px ;
        background-color:var(--body-color) !important;
    }
    .center-flex{
        display:flex ;
        align-items:center ;
        justify-content:center ;
    }
    .left-flex{
        display:flex ;
        align-items:center ;
        justify-content:flex-start ;
    }
    .between-flex{
        display:flex ;
        align-items:center ;
        justify-content:space-between ;
    }

    .MuiInputBase-formControl{
        border-radius:1rem !important ;
        background:var(--form-color) !important ;

       /* .css-1sumxir-MuiFormLabel-root-MuiInputLabel-root{
        color:var(--light-blue) !important ;
       } */
    } 
    .css-1sumxir-MuiFormLabel-root-MuiInputLabel-root{
        color:var(--light-blue) !important ;
    }
    
    a {
      text-decoration: none;
    }
    .reset {
        padding:0 ;
        margin:0 ;
    }
    
   
    
`;
